export const WorkStandardPage = () => {
  return <>WorkStandardPage</>;
};
